// Web: Next splits the dynamic import into its own chunk, so drizzle-seed only
// downloads when someone actually seeds. The native twin is where the bundle
// cost lives — see loadSeedData.native.ts.
export const loadSeedData = () => import('./seedData');
